<template>
  <Modal
    :modal-style="{ width: '410px' }"
    title="Select Stats"
  >
    <QSpinner
      v-if="loading"
      class="full-width q-mt-smd"
      :size="30"
    />
    <div
      key="form"
      class="full-height q-pa-xs scroll column"
      :class="{ 'q-pa-md': $isDesktop }"
    >
      <Checkbox
        v-model="selectAll"
        label="Select All"
        style="margin: 7px 0"
        @update:model-value="toggleSelectAll"
      />
      <Checkbox
        v-for="(label, key) in stats"
        :key="key"
        v-model="status[key]"
        :label="label"
        style="margin: 7px 0"
        :value="key"
        @update:model-value="toggleStat(key)"
      />
    </div>

    <template #buttons>
      <a
        class="q-mr-md text-black"
        href="#"
        @click.prevent="close"
      >
        Cancel
      </a>
      <QBtn
        class="no-shadow bg-primary bold q-py-smd text-white"
        :disable="disableButton"
        label="Generate"
        @click="generate"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

const VALUES = {
  media_requests: { features: ["media_request"] },
  quotas: {
    features: ["view_paper_articles", "audio_transcript", "media_request"],
  },
};

export default {
  name: "OrganisationUsageReportModal",
  components: {
    Modal,
  },
  emits: ["generate"],
  data() {
    return {
      loading: false,
      stats: {
        quotas: "Usage",
        users: "Users",
        media_requests: "Media Items",
        audience_report: "Daily Email Report Audience",
        der_delivery: "DER Delivery",
        platform_activity: "Platform Activity",
        organisation_teams: "Organisation Teams",
      },
      status: {
        quotas: false,
        users: false,
        media_requests: false,
        audience_report: false,
        der_delivery: false,
        platform_activity: false,
        organisation_teams: false,
      },
      selectedStats: [],
      selectAll: false,
    };
  },
  computed: {
    disableButton() {
      return !this.selectedStats.length;
    },
  },
  methods: {
    generate() {
      const selectedStatsParams = this.prepareStatsParams();
      this.$emit("generate", selectedStatsParams);
      this.close();
    },
    prepareStatsParams() {
      return this.selectedStats.reduce(
        (acc, stat) => ({
          ...acc,
          [stat]: VALUES[stat] || true,
        }),
        {}
      );
    },
    close() {
      this.$modals.close("OrganisationUsageReportModal");
    },
    toggleSelectAll() {
      this.selectedStats = this.selectAll ? Object.keys(this.stats) : [];

      Object.keys(this.stats).forEach((key) => {
        this.status[key] = this.selectAll;
      });
    },
    toggleStat(val) {
      const index = this.selectedStats.findIndex((stat) => stat === val);

      if (index < 0) {
        this.addStat(val);
      } else {
        this.removeStat(index);
      }
    },
    addStat(val) {
      this.selectedStats.push(val);
    },
    removeStat(index) {
      this.selectedStats.splice(index, 1);
    },
  },
};
</script>
